import { ChevronRightIcon, ChevronUpIcon, TrashIcon, XIcon } from "@primer/octicons-react";
import { Box, Checkbox, IconButton } from "@primer/react";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { thuPhiApi } from "../../../api/thuPhiApi";
import { DefaultConfirm } from "../../../components/confirm";
import DataGrid from "../../../components/data-grid";
import { IDataGridColumn } from "../../../components/data-grid/type/IDataGridProps";
import { DefaultPopup } from "../../../components/modal";
import { PlaceHolder } from "../../../components/place-holder";
import ThuPhiAddKhoanNopBtn from "../../../components/thu-phi/add-khoan-nop";
import ThuPhiDieuChinhChietKhauBtn from "../../../components/thu-phi/dieu-chinh-chiet-khau";
import ThuPhiFinishConfirmBtn from "../../../components/thu-phi/finish-confirm";
import ThuPhiHuyChungTuBtn from "../../../components/thu-phi/huy-chung-tu";
import ThuPhiSendBienLaiBtn from "../../../components/thu-phi/send-bien-lai";
import ThuPhiTaoBienLaiBtn from "../../../components/thu-phi/tao-bien-lai";
import ThuPhiThongTinTongHop from "../../../components/thu-phi/thong-tin-tong-hop";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import { useCommonContext } from "../../../contexts/common";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import {
  closeThuPhiDeleteKhoanNopConfirm,
  initialThuPhiChiTietState,
  loadThuPhiChiTietMucPhaiThuStart,
  loadThuPhiChiTietStart,
  loadThuPhiMienGiamStart,
  loadThuPhiPhanBoPhiStart,
  showThuPhiDeleteKhoanNopConfirm,
} from "../../../state/actions/thuPhiChiTietAction";
import { RootState } from "../../../state/reducers";
import { formatVND } from "../../../utils/formatVND";
import HoanPhiQuyetToanBtn from "../hoanphi-quyettoan-btn";
import "./thu-phi-chi-tiet.scss";

type ThuPhiChiTietProps = {
  sf_mucphaithu: sf_mucphaithu;
  animationOf: string;
  onClose: (isMustReload: boolean) => void;
  onReloadHocSinh?: () => void | Promise<void>;
  ts_hocsinh: any;
  nam_hoc: string;
};

const ThuPhiChiTiet = (props: ThuPhiChiTietProps) => {
  const [isShowPlaceHolder, SetIsShowPlaceHolder] = useState<boolean>(false);
  const [isLoadBienLai, setIsLoadBienLai] = useState<boolean>(false);
  useCommonContext();
  const [bienlaithu, set_bienlaithu] = useState<any[] | undefined>(undefined);
  const [ngaythu, set_ngaythu] = useState<any>(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [ngaythuOriginal, set_ngaythuOriginal] = useState<any>(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const [isNgayThuChanged, setIsNgayThuChanged] = useState<boolean>(false);
  const [namhoc_dongphi, set_namhoc_dongphi] = useState<string>(
    props.nam_hoc || "2025-2026"
  );
  const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
  const [tong_tien_da_nop_custom, set_tong_tien_da_nop_custom] =
    useState<any>(0);
  const [expandedGroups, setExpandedGroups] = useState<Set<string>>(new Set());
  const [selectedKhoanNopIds, setSelectedKhoanNopIds] = useState<any[]>([]);
  const [isDeletingSelectedKhoanNops, setIsDeletingSelectedKhoanNops] =
    useState<boolean>(false);
  const [isNeedToShowPopUp, setIsNeedToShowPopUp] = useState<boolean>(false);
  const [isSummaryCollapsed, setIsSummaryCollapsed] = useState<boolean>(false);
  const state = useSelector((x: RootState) => x.thuPhiChiTiet);
  const [mucphaithu, set_mucphaithu] = useState<any | undefined>(undefined);
  const [mucphaithu_chitiet, set_mucphaithu_chitiet] = useState<
    any | undefined
  >(undefined);
  const { dm_coso_id } = useSelector((x: RootState) => x.common);

  const dispatch = useDispatch();
  const {
    is_show_confirm_delete,
    sf_mucphaithu_miengiams,
    sf_mucphaithu,
    sf_mucphaithu_chitiet_miengiams,
    sf_mucphaithu_chitiets,
    sf_phanbophis,
    status,
  } = state;
  const isAccessibleDelete: boolean = true;
  const is_readOnly =
    sf_mucphaithu &&
    (sf_mucphaithu?.tong_tien_da_nop > 0 ||
      sf_mucphaithu?.sf_hachtoan_congno_id > 0 ||
      sf_mucphaithu?.so_chung_tu.includes("RV"));
  const is_tbtp = sf_mucphaithu && sf_mucphaithu?.sf_tbtp_id > 0;
  const is_khoanno =
    sf_mucphaithu !== null &&
    sf_mucphaithu !== undefined &&
    sf_mucphaithu.noi_dung &&
    sf_mucphaithu.noi_dung.toUpperCase().includes("KHOẢN NỢ");
  const is_tienmat =
    sf_phanbophis !== null &&
    sf_phanbophis !== undefined &&
    sf_phanbophis.length > 0 &&
    sf_phanbophis[0]?.hinh_thuc_thanh_toan?.toUpperCase().includes("TIỀN MẶT");
  const isVisibleDateBox =
    dm_coso_id === 2 || dm_coso_id === 8 || dm_coso_id === 10;
  const isHideDatbox =
    bienlaithu !== undefined && bienlaithu.length > 0 && is_tienmat;
  useEffect(() => {
    if (
      sf_phanbophis !== undefined &&
      sf_phanbophis !== null &&
      sf_phanbophis.length > 0 &&
      sf_phanbophis[0]?.so_chung_tu !== null
    ) {
      set_namhoc_dongphi(
        sf_phanbophis[0]?.nam_hoc_dong_phi == undefined
          ? props.nam_hoc
          : sf_phanbophis[0]?.nam_hoc_dong_phi
      );
      loadBienLai();
    }
  }, [sf_phanbophis, isLoadBienLai]);

  useEffect(() => {
    if (bienlaithu && bienlaithu.length > 0 && bienlaithu[0].ngay_thu_thuc_te) {
      const ngayThuFromBienLai = moment(bienlaithu[0].ngay_thu_thuc_te).format("YYYY-MM-DD HH:mm:ss");
      set_ngaythu(ngayThuFromBienLai);
      set_ngaythuOriginal(ngayThuFromBienLai);
      setIsNgayThuChanged(false);
    }
  }, [bienlaithu]);

  useEffect(() => {
    set_mucphaithu_chitiet(sf_mucphaithu_chitiets);
    handleReloadTienThuaHocSinh();
  }, [status]);
  // useEffect(() => {
  //   loadMucPhaiThu();
  // }, [state]);
  const loadBienLai = async () => {
    if (
      sf_phanbophis !== undefined &&
      sf_phanbophis !== null &&
      sf_phanbophis[0]?.so_chung_tu !== null &&
      sf_phanbophis[0]?.so_chung_tu.length > 0
    ) {
      var res = await bienLaiThuApi.get_by_chungtu(
        props.sf_mucphaithu.so_chung_tu == null
          ? sf_phanbophis[0]?.so_chung_tu
          : props.sf_mucphaithu.so_chung_tu
      );
      if (res.is_success) {
        if (res.data.length > 0) {
          set_ngaythu(res.data[0].ngay_thu_thuc_te);
        }
        set_bienlaithu(res.data);
        setIsLoadBienLai(false);
      }
    }
  };
  const loadMucPhaiThu = async () => {
    const request: sf_mucphaithu_select_byhocsinh_rq = {
      nam_hoc: props.nam_hoc,
      ts_hocsinh_id: props.ts_hocsinh.id,
    };
    var res = await mucPhaiThuApi.select_by_hocsinh(request);
    if (res.is_success) {
      set_mucphaithu(
        res.data.filter(
          (x: any) => x.so_chung_tu === props.sf_mucphaithu.so_chung_tu
        )[0]
      );
    }
  };
  const loadMucPhaiThuChiTiet = async () => {
    var res = await thuPhiApi.select_chitiet(props.sf_mucphaithu.id);
    if (res.is_success) {
      set_mucphaithu_chitiet(res.data);
    }
  };
  const handleReloadTienThuaHocSinh = async () => {
    const datasend: sf_mucphaithu_select_byhocsinh_rq = {
      ts_hocsinh_id: props.ts_hocsinh.id,
      nam_hoc: props.nam_hoc,
    };
    const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
    if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
      set_tong_tien_thua(res.data.tong_tien_thua);
    }
  };
  const nhomMienGiams = useMemo(() => {
    if (!sf_mucphaithu_chitiet_miengiams?.length) return [];

    const map = new Map<string, any>();
    sf_mucphaithu_chitiet_miengiams.forEach((mg: any) => {
      const ma_nhom =
        mg.ma_nhom_mien_giam ||
        mg.ma_hinhthucmiengiam ||
        mg.sf_hinhthucmiengiam_id?.toString();

      if (!ma_nhom || map.has(ma_nhom)) return;

      map.set(ma_nhom, {
        ma_nhom_mien_giam: ma_nhom,
        ten_nhom_mien_giam:
          mg.ten_nhom_mien_giam ||
          mg.hinh_thuc_mien_giam ||
          mg.ma_hinhthucmiengiam,
        thu_tu: mg.thu_tu || 0,
      });
    });

    return Array.from(map.values()).sort((a, b) => a.thu_tu - b.thu_tu);
  }, [sf_mucphaithu_chitiet_miengiams]);

  const mienGiamByChiTiet = useMemo(() => {
    if (!sf_mucphaithu_chitiet_miengiams?.length) return new Map<string, Record<string, number>>();

    const result = new Map<string, Record<string, number>>();

    sf_mucphaithu_chitiet_miengiams.forEach((item: any) => {
      const chiTietId = item.sf_mucphaithu_chitiet_id?.toString();
      const maNhom =
        item.ma_nhom_mien_giam ||
        item.ma_hinhthucmiengiam ||
        item.sf_hinhthucmiengiam_id?.toString();

      if (!chiTietId || !maNhom) return;

      const current = result.get(chiTietId) || {};
      current[maNhom] = (current[maNhom] || 0) + (item.so_tien_mien_giam || 0);
      result.set(chiTietId, current);
    });

    return result;
  }, [sf_mucphaithu_chitiet_miengiams]);

  const rawDataSource = useMemo(() => {
    if (!mucphaithu_chitiet?.length) return [];

    return mucphaithu_chitiet.map((item: any) => {
      const obj = { ...item };

      if (obj.sf_hachtoan_congno_id > 0) {
        obj.ten_khoan_nop = obj.sf_hachtoan_congno_noi_dung;
        obj.nhom_khoan_nop = " Quyết toán";
      }

      const mienGiamTheoNhom = mienGiamByChiTiet.get(obj.id?.toString()) || {};
      nhomMienGiams.forEach((nhom) => {
        obj[`M_${nhom.ma_nhom_mien_giam}`] = mienGiamTheoNhom[nhom.ma_nhom_mien_giam] || 0;
      });

      return obj;
    });
  }, [mucphaithu_chitiet, mienGiamByChiTiet, nhomMienGiams]);

  const dataSource = useMemo(() => {
    if (rawDataSource.length === 0) return [];

    const groupedData: Record<string, any[]> = {};
    rawDataSource.forEach((item: any) => {
      const groupKey = item.nhom_khoan_nop || "Khác";
      if (!groupedData[groupKey]) {
        groupedData[groupKey] = [];
      }
      groupedData[groupKey].push(item);
    });

    const result: any[] = [];
    const getOrder = (item: any): { thuTuNhom: number; thuTu: number } => {
      return {
        thuTuNhom: Number(item.thutu_sapxep_nhomkhoannop) || 0,
        thuTu: Number(item.thutu_sapxep) || 0,
      };
    };

    const sortedGroupKeys = Object.keys(groupedData).sort((a, b) => {
      const ordersA = groupedData[a].map(getOrder);
      const ordersB = groupedData[b].map(getOrder);

      const minNhomA = Math.min(...ordersA.map((o) => o.thuTuNhom));
      const minNhomB = Math.min(...ordersB.map((o) => o.thuTuNhom));
      if (minNhomA !== minNhomB) return minNhomA - minNhomB;

      const minThuTuA = Math.min(...ordersA.map((o) => o.thuTu));
      const minThuTuB = Math.min(...ordersB.map((o) => o.thuTu));
      if (minThuTuA !== minThuTuB) return minThuTuA - minThuTuB;

      return String(a).localeCompare(String(b), "vi");
    });

    sortedGroupKeys.forEach((groupKey: string) => {
      result.push({
        id: `group_${groupKey}`,
        isGroupHeader: true,
        nhom_khoan_nop: groupKey,
        ma_khoan_nop: "",
        ten_khoan_nop: `Nhóm: ${groupKey}`,
        groupItems: groupedData[groupKey],
        isExpanded: expandedGroups.has(groupKey),
      });

      if (expandedGroups.has(groupKey)) {
        const sortedItems = [...groupedData[groupKey]].sort((x: any, y: any) => {
          const a = getOrder(x);
          const b = getOrder(y);
          if (a.thuTu !== b.thuTu) return a.thuTu - b.thuTu;
          return String(x.ma_khoan_nop || "").localeCompare(String(y.ma_khoan_nop || ""), "vi");
        });

        sortedItems.forEach((item: any) => {
          result.push({
            ...item,
            isGroupHeader: false,
            parentGroup: groupKey,
          });
        });
      }
    });
    return result;
  }, [rawDataSource, expandedGroups]);

  const fullDataSource = useMemo(() => {
    return rawDataSource;
  }, [rawDataSource]);

  const selectedKhoanNopDetails = useMemo(() => {
    if (!selectedKhoanNopIds.length) return [];
    return rawDataSource.filter((item: any) => selectedKhoanNopIds.includes(item.id));
  }, [rawDataSource, selectedKhoanNopIds]);

  const canDeleteKhoanNop = !is_readOnly && !is_tbtp;

  useEffect(() => {
    if (!rawDataSource.length) {
      setSelectedKhoanNopIds([]);
      return;
    }

    const validIds = new Set(rawDataSource.map((item: any) => item.id));
    setSelectedKhoanNopIds((prev) => prev.filter((id) => validIds.has(id)));
  }, [rawDataSource]);

  useEffect(() => {
    if (rawDataSource.length === 0) {
      setExpandedGroups(new Set());
      return;
    }

    setExpandedGroups((prev) => {
      const next = new Set(prev);
      const uniqueGroups = new Set<string>();

      rawDataSource.forEach((item: any) => {
        uniqueGroups.add(item.nhom_khoan_nop || "Khác");
      });

      uniqueGroups.forEach((groupKey) => next.add(groupKey));

      Array.from(next).forEach((groupKey) => {
        if (!uniqueGroups.has(groupKey)) {
          next.delete(groupKey);
        }
      });

      return next;
    });
  }, [rawDataSource]);

  const toggleGroup = useCallback((groupKey: string) => {
    setExpandedGroups((prev) => {
      const next = new Set(prev);
      if (next.has(groupKey)) {
        next.delete(groupKey);
      } else {
        next.add(groupKey);
      }
      return next;
    });
  }, []);
  useEffect(() => {
    dispatch(
      initialThuPhiChiTietState({
        ...state,
        sf_mucphaithu: props.sf_mucphaithu,
      })
    );
  }, [props.sf_mucphaithu.id]);
  useEffect(() => {
    handleReload();
  }, [props.sf_mucphaithu.id]);
  useEffect(() => {
    if (status === PageBaseStatus.is_need_reload)
      dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
  }, [status]);
  const handleReload = () => {
    dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiMienGiamStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id));
    dispatch(loadThuPhiChiTietMucPhaiThuStart(props.sf_mucphaithu.id));
  };

  const handleShowDeleteKhoanNopConfirm = () => {
    if (!selectedKhoanNopDetails.length) return;
    dispatch(showThuPhiDeleteKhoanNopConfirm(selectedKhoanNopDetails[0]));
  };
  const handleCloseDeleteKhoanNopConfirm = () => {
    dispatch(closeThuPhiDeleteKhoanNopConfirm());
  };

  const isAllGridSelected = useMemo(() => {
    return rawDataSource.length > 0 && rawDataSource.every((item: any) => selectedKhoanNopIds.includes(item.id));
  }, [rawDataSource, selectedKhoanNopIds]);

  const isPartialGridSelected = useMemo(() => {
    return rawDataSource.some((item: any) => selectedKhoanNopIds.includes(item.id));
  }, [rawDataSource, selectedKhoanNopIds]);

  const handleSelectAll = useCallback((checked: boolean) => {
    if (checked) {
      setSelectedKhoanNopIds(rawDataSource.map((item: any) => item.id));
    } else {
      setSelectedKhoanNopIds([]);
    }
  }, [rawDataSource]);

  const handleGroupSelection = useCallback((groupKey: string, checked: boolean) => {
    const groupItems = rawDataSource.filter((item: any) => (item.nhom_khoan_nop || "Khác") === groupKey);
    const groupItemIds = groupItems.map((item: any) => item.id);

    setSelectedKhoanNopIds((prev: any[]) => {
      if (checked) {
        const next = [...prev];
        groupItemIds.forEach((id: any) => {
          if (!next.includes(id)) next.push(id);
        });
        return next;
      } else {
        return prev.filter((id: any) => !groupItemIds.includes(id));
      }
    });
  }, [rawDataSource]);

  const handleSubmitDeleteKhoanNop = async () => {
    if (!selectedKhoanNopDetails.length) return;

    try {
      setIsDeletingSelectedKhoanNops(true);

      for (const item of selectedKhoanNopDetails) {
        const res = await thuPhiApi.remove_khoannop(item.id);
        if (!res?.is_success) {
          showNotify({
            message: res?.message || "Bỏ khoản nộp thất bại",
            type: "warning",
          });
          return;
        }
      }

      showNotify({
        message:
          selectedKhoanNopDetails.length > 1
            ? "Đã bỏ các khoản nộp đã chọn khỏi chứng từ"
            : "Đã bỏ khoản nộp khỏi chứng từ",
        type: "success",
      });
      setSelectedKhoanNopIds([]);
      dispatch(closeThuPhiDeleteKhoanNopConfirm());
      handleReload();
    } finally {
      setIsDeletingSelectedKhoanNops(false);
    }
  };

  const onClose = useCallback(() => {
    props.onClose(false);
  }, [props]);

  const DeleteKhoanNopConfirm = () => {
    if (is_show_confirm_delete && selectedKhoanNopDetails.length > 0) {
      const isMultiple = selectedKhoanNopDetails.length > 1;
      return (
        <DefaultConfirm
          type="danger"
          onClose={handleCloseDeleteKhoanNopConfirm}
          onConfirmed={handleSubmitDeleteKhoanNop}
          text={
            isMultiple
              ? `Bạn có chắc chắn muốn bỏ ${selectedKhoanNopDetails.length} khoản nộp đã chọn khỏi chứng từ?`
              : "Bạn có chắc chắn muốn bỏ khoản nộp này khỏi chứng từ?"
          }
          text_close_button={"Không bỏ"}
          text_confirm_button={"Bỏ khoản nộp"}
          is_saving={isDeletingSelectedKhoanNops}
        />
      );
    }
    return <></>;
  };
  const UpdateNgayThu = async (so_chung_tu: string, ngayThuValue: string) => {
    const res = await bienLaiThuApi.update_ngaythu({
      so_chung_tu: so_chung_tu,
      ngay_thu_thuc_te: moment(ngayThuValue).format("YYYY-MM-DDTHH:mm:ss"),
    });

    if (res?.is_success) {
      set_ngaythu(ngayThuValue);
      set_ngaythuOriginal(ngayThuValue);
      showNotify({ message: "Cập nhật thành công", type: "success" });
      loadBienLai();
      return;
    }

    showNotify({ message: res?.message || "Cập nhật thất bại", type: "warning" });
  };

  const UpdateNoiDung = async (noiDungValue: string) => {
    const res = await mucPhaiThuApi.update_noi_dung({
      sf_mucphaithu_id: props.sf_mucphaithu.id,
      noi_dung: noiDungValue,
    });

    if (res?.is_success) {
      const nextMucPhaiThu = {
        ...(mucphaithu || props.sf_mucphaithu),
        noi_dung: noiDungValue,
      };
      set_mucphaithu(nextMucPhaiThu);
      dispatch(loadThuPhiChiTietMucPhaiThuStart(props.sf_mucphaithu.id));
      showNotify({ message: "Cập nhật thành công", type: "success" });
      return;
    }

    showNotify({ message: res?.message || "Cập nhật thất bại", type: "warning" });
  };

  const columns = useMemo((): IDataGridColumn[] => {
    const result: IDataGridColumn[] = [];


    // Cột Nhóm với expand/collapse
    result.push({
      caption: "Nhóm",
      id: "nhom_khoan_nop",
      dataField: "nhom_khoan_nop",
      width: 180,
      align: "left",
      fixed: "left",
      headerRender: () => (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {canDeleteKhoanNop && (
            <Checkbox
              checked={isAllGridSelected}
              indeterminate={isPartialGridSelected && !isAllGridSelected}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleSelectAll(e.target.checked)}
            />
          )}
          <Box sx={{ marginLeft: "8px" }}>Nhóm</Box>
        </Box>
      ),
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          const groupKey = data.nhom_khoan_nop || "Khác";
          const isExpanded = expandedGroups.has(groupKey);

          const groupItems = rawDataSource.filter(
            (item: any) => (item.nhom_khoan_nop || "Khác") === groupKey
          );
          const groupItemIds = groupItems.map((item: any) => item.id);
          const isAllGroupSelected =
            groupItemIds.length > 0 &&
            groupItemIds.every((id: any) => selectedKhoanNopIds.includes(id));
          const isPartialGroupSelected = groupItemIds.some((id: any) =>
            selectedKhoanNopIds.includes(id)
          );

          return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                aria-label=""
                variant="invisible"
                size="small"
                onClick={() => toggleGroup(groupKey)}
              />
              {canDeleteKhoanNop && (
                <Checkbox
                  checked={isAllGroupSelected}
                  indeterminate={isPartialGroupSelected && !isAllGroupSelected}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleGroupSelection(groupKey, e.target.checked)}
                />
              )}
              <Box
                sx={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginLeft: "8px",
                  color: "#0969da",
                }}
              >
                Nhóm: {groupKey}
              </Box>
            </Box>
          );
        }
        return <span>{data.nhom_khoan_nop || ""}</span>;
      },
    });

    // Cột Tên khoản nộp (gộp với Mã)
    result.push({
      caption: "Tên khoản nộp",
      id: "ten_khoan_nop",
      dataField: "ten_khoan_nop",
      width: 200,
      fixed: "left",
      align: "left",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{data.ten_khoan_nop || ""}</span>
            {data.ma_khoan_nop && (
              <span
                style={{ fontSize: "0.85em", color: "#6c757d", opacity: 0.7 }}
              >
                {data.ma_khoan_nop}
              </span>
            )}
          </div>
        );
      },
    });

    // Cột Định mức
    result.push({
      caption: "Định mức",
      id: "so_tien_dinh_muc",
      dataField: "so_tien_dinh_muc",
      width: 100,
      align: "right",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_dinh_muc || 0)}</span>;
      },
    });

    // Cột Miễn giảm (nếu có)
    if (nhomMienGiams && nhomMienGiams.length > 0) {
      result.push({
        caption: "Miễn giảm",
        id: "mien_giam",
        align: "center",
        columns: [
          ...nhomMienGiams.map((x) => ({
            caption: x.ten_nhom_mien_giam,
            id: `M_${x.ma_nhom_mien_giam}`,
            dataField: `M_${x.ma_nhom_mien_giam}`,
            width: 100,
            align: "right" as const,
            cellRender: (data: any) => {
              if (data.isGroupHeader) {
                return <span></span>;
              }
              return (
                <span>
                  {formatVND(data[`M_${x.ma_nhom_mien_giam}`] || 0)}
                </span>
              );
            },
          })),
          {
            caption: "Tổng",
            id: "so_tien_mien_giam",
            dataField: "so_tien_mien_giam",
            width: 130,
            align: "right" as const,
            cellRender: (data: any) => {
              if (data.isGroupHeader) {
                return <span></span>;
              }
              return <span>{formatVND(data.so_tien_mien_giam || 0)}</span>;
            },
          },
        ],
      });
    }

    // Cột Phải nộp
    result.push({
      caption: "Phải nộp",
      id: "so_tien_phai_nop",
      dataField: "so_tien_phai_nop",
      width: 100,
      align: "right",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_phai_nop || 0)}</span>;
      },
    });

    // Cột Đã nộp
    result.push({
      caption: "Đã nộp",
      id: "so_tien_da_nop",
      dataField: "so_tien_da_nop",
      width: 100,
      align: "right",
      cellRender: (data: any) => {
        if (data.isGroupHeader) {
          return <span></span>;
        }
        return <span>{formatVND(data.so_tien_da_nop || 0)}</span>;
      },
    });

    return result;
  }, [
    expandedGroups,
    toggleGroup,
    nhomMienGiams,
    rawDataSource,
    selectedKhoanNopIds,
    canDeleteKhoanNop,
    isAllGridSelected,
    isPartialGridSelected,
    handleSelectAll,
    handleGroupSelection,
  ]);

  const totalSummary = useMemo(
    () => [
      {
        dataField: "so_tien_dinh_muc",
        summaryType: "sum" as const,
        customizeRender: (_data: any[], sumValue?: any) => (
          <span>{formatVND(sumValue || 0)}</span>
        ),
      },
      {
        dataField: "so_tien_mien_giam",
        summaryType: "sum" as const,
        customizeRender: (_data: any[], sumValue?: any) => (
          <span>{formatVND(sumValue || 0)}</span>
        ),
      },
      {
        dataField: "so_tien_phai_nop",
        summaryType: "sum" as const,
        customizeRender: (_data: any[], sumValue?: any) => (
          <span>{formatVND(sumValue || 0)}</span>
        ),
      },
      {
        dataField: "so_tien_da_nop",
        summaryType: "sum" as const,
        customizeRender: (_data: any[], sumValue?: any) => (
          <span>{formatVND(sumValue || 0)}</span>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DefaultPopup
        width={"100%"}
        height="98vh"
        title={
          (mucphaithu || props.sf_mucphaithu).so_chung_tu +
          ": " +
          ((mucphaithu || props.sf_mucphaithu).noi_dung || "") +
          " (" +
          (props.ts_hocsinh.ma_hs || "") +
          " - " +
          (props.ts_hocsinh.ho_ten || "") +
          " - " +
          (props.ts_hocsinh.ten_khoi || "") +
          " - " +
          (props.ts_hocsinh.ten_lop + ")" || "")
        }
        onClose={onClose}
      >
        <Box sx={{ width: "100%" }}>
          {isShowPlaceHolder && <PlaceHolder line_number={20} />}
          {!isShowPlaceHolder && (
            <Box sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                <Box sx={{ width: "100%" }}>
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      alignItems: "center",
                      gap: 2,
                      p: 2,
                      border: "1px solid",
                      borderColor: "border.default",
                      borderRadius: 2,
                      bg: "canvas.subtle",
                    }}
                  >
                    {canDeleteKhoanNop && selectedKhoanNopIds.length > 0 && (
                      <Button
                        sx={{ ml: 0 }}
                        leadingVisual={TrashIcon}
                        variant="danger"
                        size="small"
                        text={`Bỏ ${selectedKhoanNopIds.length} khoản nộp đã chọn`}
                        onClick={handleShowDeleteKhoanNopConfirm}
                        isLoading={isDeletingSelectedKhoanNops}
                      />
                    )}

                    <ThuPhiAddKhoanNopBtn
                      disabled={
                        (bienlaithu !== undefined && bienlaithu.length > 0) ||
                        is_readOnly ||
                        // isThuPhiTemp ||
                        is_tbtp ||
                        is_khoanno ||
                        (sf_phanbophis !== null &&
                          sf_phanbophis !== undefined &&
                          sf_phanbophis.length > 0 &&
                          sf_phanbophis[0]?.so_chung_tu !== null &&
                          sf_phanbophis[0]?.so_chung_tu !== undefined &&
                          sf_phanbophis[0]?.so_chung_tu.length > 0)
                      }
                      filter={{
                        nam_hoc: props.nam_hoc,
                        dm_he_id: props.ts_hocsinh.dm_he_id,
                        dm_truong_id: props.ts_hocsinh.dm_truong_id,
                        dm_khoi_id: props.ts_hocsinh.dm_khoi_id,
                      }}
                      nam_hoc={props.nam_hoc}
                      sf_mucphaithu={props.sf_mucphaithu}
                      ts_hocsinh_id={props.ts_hocsinh.id}
                      sf_khoannop_ids_added={dataSource.map(
                        (x: any) => x.sf_khoannop_id
                      )}
                      onChanged={() => {
                        dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
                        loadMucPhaiThu();
                      }}
                    />

                    {/* <ThuPhiHinhThucThuPhiBtn
                        disabled={
                          isHideDatbox ||
                          false ||
                          props.sf_mucphaithu.sf_hachtoan_congno_id > 0 ||
                          props.sf_mucphaithu.so_chung_tu.includes("RV") ||
                          (bienlaithu !== undefined &&
                            bienlaithu.length > 0)
                        }
                        sf_mucphaithu={mucphaithu || props.sf_mucphaithu}
                        sf_bienlaithu={bienlaithu}
                        ts_hocsinh={props.ts_hocsinh}
                        onChanged={() => {
                          dispatch(
                            loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id)
                          );
                          handleReload();
                          loadMucPhaiThu();
                        }}
                      /> */}

                    <HoanPhiQuyetToanBtn
                      disabled={
                        (bienlaithu !== undefined && bienlaithu.length > 0) ||
                        is_readOnly ||
                        // isThuPhiTemp ||
                        is_tbtp ||
                        (sf_phanbophis !== null &&
                          sf_phanbophis !== undefined &&
                          sf_phanbophis.length > 0 &&
                          sf_phanbophis[0]?.so_chung_tu !== null &&
                          sf_phanbophis[0]?.so_chung_tu !== undefined &&
                          sf_phanbophis[0]?.so_chung_tu.length > 0)
                      }
                      sf_mucphaithu={props.sf_mucphaithu}
                      onChanged={() => {
                        dispatch(loadThuPhiMienGiamStart(props.sf_mucphaithu.id));
                        dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
                        loadMucPhaiThu();
                      }}
                    />
                    <ThuPhiDieuChinhChietKhauBtn
                      sf_mucphaithu={props.sf_mucphaithu}
                      disabled={
                        (bienlaithu !== undefined && bienlaithu.length > 0) ||
                        is_readOnly ||
                        false
                      }
                      onChanged={() => {
                        dispatch(loadThuPhiMienGiamStart(props.sf_mucphaithu.id));
                        dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
                        loadMucPhaiThu();
                      }}
                      ts_hocsinh={props.ts_hocsinh}
                    />
                    <ThuPhiFinishConfirmBtn
                      disabled={
                        (bienlaithu !== undefined && bienlaithu.length > 0) ||
                        !sf_phanbophis ||
                        sf_phanbophis.length === 0 ||
                        !sf_phanbophis[0]?.hinh_thuc_thanh_toan
                      }
                      sf_mucphaithu={props.sf_mucphaithu}
                      ts_hocsinh={props.ts_hocsinh}
                      onChanged={async () => {
                        setIsLoadBienLai(true);
                        setIsNeedToShowPopUp(true);
                        dispatch(
                          loadThuPhiChiTietMucPhaiThuStart(props.sf_mucphaithu.id)
                        );
                        dispatch(loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id));
                        loadMucPhaiThuChiTiet();
                        await props.onReloadHocSinh?.();
                      }}
                      ngaythu={ngaythu}
                      nam_hoc_dong_phi={namhoc_dongphi}
                    />
                    <ThuPhiTaoBienLaiBtn
                      buttonText="In biên lai"
                      disabled={
                        bienlaithu === undefined ||
                        (bienlaithu !== undefined && bienlaithu.length === 0) ||
                        props.sf_mucphaithu.sf_hachtoan_congno_id > 0
                      }
                      sf_mucphaithu={props.sf_mucphaithu}
                      printType="bienlai"
                    />

                    <ThuPhiSendBienLaiBtn
                      isNeedToShowPopUp={isNeedToShowPopUp}
                      onPopUpOpened={() => {
                        setIsNeedToShowPopUp(false);
                      }}
                      printDisabled={
                        bienlaithu === undefined ||
                        (bienlaithu !== undefined && bienlaithu.length === 0) ||
                        props.sf_mucphaithu.sf_hachtoan_congno_id > 0
                      }
                      disabled={
                        bienlaithu === undefined ||
                        (bienlaithu !== undefined && bienlaithu.length === 0) ||
                        props.sf_mucphaithu.sf_hachtoan_congno_id > 0
                      }
                      sf_mucphaithu={props.sf_mucphaithu}
                      ts_hocsinh_id={props.ts_hocsinh.id}
                    />

                    <ThuPhiSendBienLaiBtn
                      buttonText="Thông báo phí"
                      emailType="thongbaophi"
                      printDisabled={
                        bienlaithu !== undefined && bienlaithu.length > 0
                      }
                      disabled={
                        bienlaithu !== undefined && bienlaithu.length > 0
                      }
                      sf_mucphaithu={props.sf_mucphaithu}
                      ts_hocsinh_id={props.ts_hocsinh.id}
                    />

                    {sf_mucphaithu &&
                      sf_mucphaithu.sf_mucphaithu_root_id === 0 &&
                      isAccessibleDelete && (
                        <ThuPhiHuyChungTuBtn
                          disabled={
                            false ||
                            props.sf_mucphaithu.sf_hachtoan_congno_id > 0 ||
                            props.sf_mucphaithu.so_chung_tu.includes("NO")
                          }
                          sf_mucphaithu_id={props.sf_mucphaithu.id}
                          onChanged={() => {
                            props.onClose(true);
                          }}
                        />
                      )}
                  </Box>
                </Box>

                {/* Ngày thu thực tế và Người thu - Trên DataGrid */}
                {/* {bienlaithu && bienlaithu.length > 0 && (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={3}
                      px={2}
                      py={2}
                      mb={1}
                      bg="canvas.subtle"
                      borderRadius={2}
                      fontSize={1}
                    >
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box as="label" fontWeight="semibold" color="fg.muted" sx={{ whiteSpace: "nowrap" }}>
                          Ngày thu thực tế:
                        </Box>
                        <TextInput
                          type="date"
                          value={moment(ngaythu).format("YYYY-MM-DD")}
                          onChange={(e) => {
                            const newDate = moment(e.target.value).format("YYYY-MM-DD HH:mm:ss");
                            set_ngaythu(newDate);
                            setIsNgayThuChanged(moment(newDate).format("YYYY-MM-DD") !== moment(ngaythuOriginal).format("YYYY-MM-DD"));
                          }}
                          size="small"
                          sx={{ width: "auto" }}
                        />
                        <IconButton
                          icon={isNgayThuChanged ? CheckIcon : PencilIcon}
                          aria-label={isNgayThuChanged ? "Lưu" : "Sửa"}
                          variant={isNgayThuChanged ? "primary" : "default"}
                          size="small"
                          onClick={() => {
                            if (isNgayThuChanged && sf_phanbophis && sf_phanbophis[0]?.so_chung_tu) {
                              UpdateNgayThu(sf_phanbophis[0].so_chung_tu);
                              set_ngaythuOriginal(ngaythu);
                              setIsNgayThuChanged(false);
                            }
                          }}
                          disabled={!isNgayThuChanged}
                        />
                      </Box>
                      <Box display="flex" alignItems="center" gap={2}>
                        <Box as="label" fontWeight="semibold" color="fg.muted" sx={{ whiteSpace: "nowrap" }}>
                          Người thu:
                        </Box>
                        <Box as="span" fontWeight="semibold" color="fg.default">
                          {bienlaithu[0]?.nguoi_thu || "N/A"}
                        </Box>
                      </Box>
                    </Box>
                  )} */}

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: ["column", null, "row"],
                    gap: 2,
                    width: "100%",
                    position: "relative",
                  }}
                >
                  {!isSummaryCollapsed && (
                    <IconButton
                      aria-label="Ẩn thông tin tổng hợp"
                      title="Ẩn thông tin tổng hợp"
                      icon={ChevronRightIcon}
                      onClick={() => setIsSummaryCollapsed(true)}
                      sx={{
                        display: ["none", null, "inline-flex"],
                        position: "absolute",
                        top: "50%",
                        right: "calc(35% - 20px)",
                        transform: "translateY(-50%)",
                        zIndex: 3,
                        color: "fg.muted",
                        backgroundColor: "canvas.default",
                        border: "1px solid",
                        borderColor: "border.default",
                        boxShadow: "shadow.small",
                        transition: "right 0.3s ease, transform 0.3s ease",
                      }}
                    />
                  )}

                  {isSummaryCollapsed && (
                    <IconButton
                      aria-label="Hiện thông tin tổng hợp"
                      title="Hiện thông tin tổng hợp"
                      icon={ChevronRightIcon}
                      onClick={() => setIsSummaryCollapsed(false)}
                      sx={{
                        display: ["none", null, "inline-flex"],
                        position: "absolute",
                        top: "50%",
                        right: -20,
                        transform: "translateY(-50%) rotate(180deg)",
                        zIndex: 3,
                        color: "fg.muted",
                        backgroundColor: "canvas.default",
                        border: "1px solid",
                        borderColor: "border.default",
                        boxShadow: "shadow.small",
                      }}
                    />
                  )}
                  <Box
                    sx={{
                      flex: ["1 1 100%", null, isSummaryCollapsed ? "1 1 100%" : "1 1 65%"],
                      minWidth: 0,
                      transition: "all 0.3s ease",
                    }}
                  >
                    <Box
                      sx={{
                        overflow: "hidden",
                        borderRadius: 2,
                      }}
                    >
                      <DataGrid
                        dataSource={dataSource}
                        columns={columns as IDataGridColumn[]}
                        height={window.innerHeight - 260}
                        isLoading={false}
                        paging={{ enable: false }}
                        selection={
                          canDeleteKhoanNop
                            ? {
                              mode: "multiple",
                              selectedRowKeys: selectedKhoanNopIds,
                              onSelectionChanged: (keys) => setSelectedKhoanNopIds(keys),
                            }
                            : undefined
                        }
                        totalSummary={totalSummary}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      position: "relative",
                      display: ["block", null, isSummaryCollapsed ? "none" : "block"],
                      flex: ["1 1 100%", null, "1 1 35%"],
                      maxWidth: ["100%", null, "35%"],
                      minWidth: 0,
                      overflow: "hidden",
                      opacity: 1,
                      transform: ["none", null, "translateX(0)"],
                      pointerEvents: "auto",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: 2,
                        height: "100%",
                      }}
                    >
                      <ThuPhiThongTinTongHop
                        sf_mucphaithu={mucphaithu || props.sf_mucphaithu}
                        ts_hocsinh={props.ts_hocsinh}
                        sf_phanbophis={sf_phanbophis}
                        dataSource={fullDataSource}
                        tong_tien_thua={tong_tien_thua}
                        tong_tien_da_nop_custom={tong_tien_da_nop_custom}
                        sf_bienlaithu={bienlaithu}
                        ngaythu={ngaythu}
                        onNgayThuChange={(newDate: string) => {
                          set_ngaythu(newDate);
                          setIsNgayThuChanged(moment(newDate).format("YYYY-MM-DD") !== moment(ngaythuOriginal).format("YYYY-MM-DD"));
                        }}
                        onUpdateNgayThu={async (newDate: string) => {
                          if (sf_phanbophis && sf_phanbophis[0]?.so_chung_tu) {
                            await UpdateNgayThu(sf_phanbophis[0].so_chung_tu, newDate);
                            setIsNgayThuChanged(false);
                          }
                        }}
                        onNoiDungChange={(newNoiDung: string) => {
                          set_mucphaithu((prev: any) => ({
                            ...(prev || props.sf_mucphaithu),
                            noi_dung: newNoiDung,
                          }));
                        }}
                        onUpdateNoiDung={async (newNoiDung: string) => {
                          await UpdateNoiDung(newNoiDung);
                        }}
                        onPhanBoPhiChanged={() => {
                          dispatch(loadThuPhiPhanBoPhiStart(props.sf_mucphaithu.id));
                          dispatch(loadThuPhiChiTietStart(props.sf_mucphaithu.id));
                          dispatch(loadThuPhiChiTietMucPhaiThuStart(props.sf_mucphaithu.id));
                        }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
              <ModalActions>
                <Button
                  variant="default"
                  leadingVisual={XIcon}
                  text="Đóng"
                  onClick={onClose}
                />
              </ModalActions>
              <DeleteKhoanNopConfirm />
            </Box>
          )}
        </Box>
      </DefaultPopup>
    </React.Fragment>
  );
};
export default ThuPhiChiTiet;
